import { render } from "./EjectAnnouncement.vue?vue&type=template&id=49ff66b8&scoped=true"
import script from "./EjectAnnouncement.vue?vue&type=script&lang=js"
export * from "./EjectAnnouncement.vue?vue&type=script&lang=js"

import "./EjectAnnouncement.vue?vue&type=style&index=0&id=49ff66b8&lang=stylus&scoped=true"
import "./EjectAnnouncement.vue?vue&type=style&index=1&id=49ff66b8&lang=stylus"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ff66b8"]])

export default __exports__